import React from "react";

function Field({ label, value, bordered, highlight }: { label: string; value: React.ReactNode; bordered?: boolean; highlight?: boolean }) {
  return (
    <div style={{ borderBottom: bordered ? "1px solid #ECECEC" : undefined, padding: "12px 0" }}>
      <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 4, textTransform: "capitalize" }}>{label}</div>
      <div style={{ fontSize: 14, color: highlight ? "#DC1A22" : undefined, fontWeight: highlight ? 500 : undefined }}>{value}</div>
    </div>
  );
}

export default function BookingSummaryPanel({ paymentInfo }: { paymentInfo: any }) {
  return (
    <div className="b2c2b-section_panel" style={{ marginBottom: 24, overflow: "hidden" }}>
      <div className="b2c2b-section_panel-header">
        <label>Booking summary</label>
      </div>
      <div className="booking-summary_grid">
        <Field label="Tour" value={paymentInfo.package_name} bordered highlight />
        <Field label="Tour code" value={paymentInfo.code} bordered />
        <Field label="Departure date" value={paymentInfo.departure_date || "—"} bordered />
        <Field label="Destination" value={paymentInfo.destination} bordered />
        <Field label="Traveler" value={paymentInfo.traveler || "—"} />
        <Field label="Pax" value={`${paymentInfo.total_quantity} Pax`} />
      </div>
    </div>
  );
}
